module.exports = __webpack_public_path__ + "static/media/aito_ale_small.dfcde387.png";